var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "map-world-heat" }, [
    _vm.loading
      ? _c("div", { staticClass: "map-overlay" }, [_vm._m(0)])
      : _vm._e(),
    _c("div", {
      ref: "mapWorldHeat",
      class: "map-heat " + _vm.id,
      attrs: { id: _vm.id },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "map-overlay-box" }, [
      _c("div", { staticClass: "loader" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }